<template>
  <div class="comparison-skill-page">
    <div class="skill-name">竞争力分析   ({{profession_name}})</div>
    <div class="skill-content">
      <div class="content-title">
        <p>对方的能力信息</p>
        <img src="https://files.wondercv.com/PC/planning/position/vs.png" alt="">
        <p>我的能力信息</p>
      </div>
      <div class="content-list">
        <div class="list-item">
          <p class="she-item">{{she.edu_degree}}学历，高于{{she.capability_analysis.degree_percent}}%的竞争对手</p>
          <p class="item-tags">教育背景</p>
          <p class="me-item">{{me.edu_degree}}学历，高于{{me.capability_analysis.degree_percent}}%的竞争对手</p>
        </div>
        <div class="list-item">
          <p class="she-item" v-if="she.capability_analysis.related_works > 0">在该行业有 {{she.capability_analysis.related_works}} 段相关工作经验，其中有 {{she.capability_analysis.big_name}} 段为大厂经验</p>
          <p class="she-item" v-else>尚无相关工作经验</p>
          <p class="item-tags">工作背景</p>
          <p class="me-item" v-if="me.capability_analysis.related_works > 0">在该行业有 {{me.capability_analysis.related_works}} 段相关工作经验，其中有 {{me.capability_analysis.big_name}} 段为大厂经验</p>
          <p class="me-item" v-else>尚无相关工作经验</p>
        </div>
        <div class="list-item">
          <p class="she-item" v-if="skill.comparison.length > 0">{{skill.comparison.length}} 项必备技能，打败 {{skill_score_list[skill.comparison.length]}}% 的竞争对手</p>
          <p class="she-item" v-else>暂无相关职位必备技能</p>
          <p class="item-tags">必备技能</p>
          <p class="me-item" v-if="skill.me.length > 0">{{skill.me.length}} 项必备技能，打败 {{skill_score_list[skill.me.length]}}% 的竞争对手</p>
          <p class="me-item" v-else>你没有掌握相关职位必备技能</p>
        </div>
      </div>
      <p class="info-title">知名企业工作经验有利于提升行业竞争力</p>
      <div class="company-list">
        <div class="company-item" v-for="(item,index) in companyList" :key="index">
          <img :src="item.company_logo" alt="">
          <p class="company_name">{{item.company_nickname || item.company_full_name}}</p>
          <p class="company_city">{{item.city}} · {{item.industry}}</p>
          <p class="company_jobs" @click="goDetail(item)"><span class="jobs_count">{{item.jobs_count}}个</span> 热招职位</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../../api/index"
  export default {
    name: "comparison-skill",
    props: {
      me: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      she: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      profession_name:{
        type:String,
        default:''
      },
      skill: {
        type: Object,
        default: ()=>{
          return {
            me: [],
            comparison: []
          }
        }
      },
      profession_id:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        companyList:[],
        skill_score_list:[0,5,22,31,47,64,71,79,88,95]
      }
    },
    async mounted(){
      let res = await api.planning.getProfessionCompany(this.profession_id)
      this.companyList = res.data
    },
    methods:{
      goDetail(data){
        let url = process.env.NODE_ENV === 'production' ? 'https://www.wondercv.com/company/'+ data.token+'.html': 'https://www.wondercv.cn/company/'+ data.token+'.html'
        window.open(url)
      }
    }
  }
</script>

<style scoped lang="scss">
.comparison-skill-page{
  margin-bottom: 50px;
  .skill-name{
    font-size: 32px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 45px;
    margin-bottom: 34px;
  }
  .skill-content{
    width: 1200px;
    height: 628px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-image: url("https://files.wondercv.com/PC/editor/planning/people/bgcard_skillsmin.png");
    background-size: 100% 100%;
    padding:24px 32px 32px 32px;
    box-sizing: border-box;
    // overflow-y: scroll;
    .content-title{
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
      img{
        display: block;
        width: 176px;
        height: 42px;
        margin: 0 22px;
      }
    }
    .content-list{
      height: 216px;
      background: #252830;
      border-radius: 9px;
      margin-top: 22px;
      padding: 32px 30px;
      box-sizing: border-box;
      .list-item{
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        margin-bottom: 16px;
        .she-item{
          width: 478px;
          height: 40px;
          background-image: url('https://files.wondercv.com/PC/planning/position/left.png');
          background-size: 100% 100%;
          line-height: 40px;
          text-align: right;
          padding-right: 50px;
          color: #fff;
          font-size: 14px;
        }
        .me-item{
          width: 478px;
          height: 40px;
          background-image: url('https://files.wondercv.com/PC/planning/position/right.png');
          background-size: 100% 100%;
          line-height: 40px;
          text-align: left;
          padding-left: 50px;
          color: #fff;
          font-size: 14px;
        }
        .item-tags{
          font-size: 14px;
          width: 56px;
          margin: 0 32px;
          color: #fff;
          white-space: nowrap;
        }
      }
    }
    .info-title{
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      color:#fff;
      margin:32px 0 24px 0;
    }
    .company-list{
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .company-item{
        width: 214px;
        height: 234px;
        background: #252830;
        border-radius: 8px;
        padding: 32px 0 24px 0;
        box-sizing: border-box;
        img{
          display: block;
          width: 60px;
          height: 60px;
          border-radius: 8px;
          margin: 0 auto;
        }
        .company_name{
          width: 72px;
          margin: 0 auto;
          overflow: hidden;
          font-size: 18px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 25px;
          margin-top: 16px;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .company_city{
          font-size: 12px;
          font-weight: 400;
          color: #BCBCBC;
          line-height: 17px;
          margin-top: 6px;
          text-align: center;
        }
        .company_jobs{
          width: 165px;
          height: 34px;
          border-radius: 18px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          text-align: center;
          line-height: 36px;
          color: #fff;
          margin: 20px auto 0 auto;
          cursor: pointer;
          span{
            color: #FF8569;
          }
        }
        .company_jobs:hover{
          height: 36px;
          background: linear-gradient(180deg, #FF9F79 0%, #FF6644 100%);
          border: none;
          span{
            color: #fff;
          }
        }
      }
    }
  }
  .skill-content::-webkit-scrollbar{
    display: none;
  }
}
</style>
